var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"comment-list"},_vm._l((_vm.comments),function(comment){return _c('VComment',_vm._b({key:comment.id,on:{"commentToDelete":function($event){return _vm.$emit('commentToDelete', $event)}}},'VComment',comment,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }